import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ConfirmModal = ({ isOpen, toggle, onConfirm, status }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Change Status</ModalHeader>
      <ModalBody>Are you sure you want to <span className={status == "active" || status===true ? `text-primary text-capitalize`:`text-success text-capitalize`}>{status == "active" || status===true ? "deactivate" : "activate" }</span> this?</ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={
            status === "active" || status === true
              ? "primary"
              : status === "inactive" || status === false||status=="Inactive"
              ? "success"
              : "danger"
          }
          onClick={onConfirm}
        >
          Yes, {status == "active" || status === true ? "Deactivate" : "Activate"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
